import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getAreaNamesList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class generalLocalities extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              arealist: [],
              openedAdd:false
        };

        this.getAreaNamesList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_school', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

      $(document).on('click', '.stamp_it', function () {

        var item_id = $(this).data("id");

        THIS.openInfo(item_id);
        
      });

    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }


    getAreaNamesList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getAreaNamesList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            arealist: res.list
            
          });
        } else {
          this.setState({
            arealist: [],
          });
        }
      });
    }    

    render() {

        const { arealist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Localities</h4>
                 
 
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&

                     <div class="row col-lg-12">
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                          <label>Image name</label>
                          <input type="text" class="form-control" name="name" />

                        </div>

                        <div class="form-row">
                          
                          <label>Choose image</label>

                          <input type="file" class="form-control" name="image" />

                        </div>

                        <div class="form-row">
                          <button class="btn btn-primary btn-sm">Upload Image</button>
                        </div>

                      </div>

                     </div>
                  }
                  
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>
                          <th >
                            <strong>S.No</strong>
                          </th>
                          <th >
                            <strong>Area Name</strong>
                          </th>
                      
                          <th >
                            <strong>City</strong>
                          </th>
                     
                          <th>
                            <strong>Latitude</strong>
                          </th>

                          <th >
                            <strong>Longtitude</strong>
                          </th>

                          <th >
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {arealist.map((item, i) => {     
                      
                       return <tr>
                          <td  >
                            {i+1}
                          </td>
                          <td >
                           {item.area_name}
                          </td>
                          
                        
                          <td  >
                            {item.city}
                          </td>
                         
                          <td  >
                            {item.latitude}
                          </td>
                         
                          <td  >
                            {item.longtitude}
                          </td>
                          
                          <td dangerouslySetInnerHTML={{__html: item.action}} />                             

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default generalLocalities;


// WEBPACK FOOTER //
// ./src/components/bewise/generalLocalities.jsx